export const environment = {
  adobeLaunchScriptSource:
    'https://assets.adobedtm.com/267c22ecc15c/514441733727/launch-570dd6531db5-staging.min.js',
  production: true,
  showProvenueErrorInfo: true,
  apiUrl: 'https://pre-groupsales.service.3ddigitalvenue.com/api',
  oktaData: {
    clientId: '0oarywblm4Q2cVXz6357',
    issuer: 'https://ids.mlb.com/oauth2/aus1m088yK07noBfh356',
  },
  analytics: {
    club: [],
    mmc: '',
  },
};
